import { EventComponent, PlannerEcsSystem, ProductType } from '@inter-ikea-storageone/range';
import { HierarchyUtils, Transform, TransformUtils, Vector } from '@inter-ikea-core/core';
import { getFrameGroupsWithSlidingDoors } from '../../utils/slidingDoorUtils';
/**
 * The system handles that frames with sliding doors are correctly grouped together
 * when loading a solution or after doing undo/redo
 */
export class PlatsaSlidingDoorPlacementSystem extends PlannerEcsSystem {
    constructor(coreApi) {
        super(coreApi, 'PlatsaSlidingDoorPlacementSystem', EventComponent.id);
    }
    onAdd() { }
    onUpdate(entity, oldComponent, newComponent) {
        if (newComponent.event === 'history' && this.sceneIncludesSlidingDoors()) {
            const frameGroupsWithSlidingDoor = getFrameGroupsWithSlidingDoors(this.coreApi);
            frameGroupsWithSlidingDoor.forEach(frames => {
                this.offsetSlidingDoorFrontPosition(frames);
            });
        }
    }
    onRemove() { }
    sceneIncludesSlidingDoors() {
        return this.coreApi.entities.getByProductType(ProductType.PLATSA_SLIDING_DOOR_ASM).length > 0;
    }
    sortByPosition(a, b) {
        const positionA = TransformUtils.worldPosition(a);
        const positionB = TransformUtils.worldPosition(b);
        return positionA.X === positionB.X ? positionA.Z - positionB.Z : positionA.X - positionB.X;
    }
    offsetSlidingDoorFrontPosition(frames) {
        const doorOffsetBackPosition = 20;
        const doorOffsetFrontPosition = 30;
        const sortedFrames = frames.sort(this.sortByPosition);
        sortedFrames.forEach((frame, index) => {
            const slidingDoor = HierarchyUtils.children(frame).find(child => this.coreApi.entities.isProductType(child, ProductType.PLATSA_SLIDING_DOOR_ASM));
            if (!slidingDoor) {
                return;
            }
            const slidingDoorFront = HierarchyUtils.children(slidingDoor).find(child => this.coreApi.entities.isProductType(child, ProductType.PLATSA_SLIDING_DOOR_FRONT));
            if (!slidingDoorFront) {
                return;
            }
            // every other sliding door front in group should be in front versus back
            const doorOffset = index % 2 === 0 ? doorOffsetBackPosition : doorOffsetFrontPosition;
            TransformUtils.setLocalTransform(slidingDoorFront, new Transform(new Vector(0, 0, doorOffset)));
        });
    }
}
//# sourceMappingURL=PlatsaSlidingDoorPlacementSystem.js.map